<template>
	<div class="gantt-time-board-chart" style="transition:1s">
		<Dialog
			:dialog="dialog" 
			@agree="onClickAgree"
			@disagree="onClickDisagree"
		/>
		<TCDialogScheduleInfo
			:dialog="dialog_schedule_info"
			@close="onCloseDialog"
			@disagree="onClickDisagree" />
		<TCDialogCalendar
			:dialog="dialog_calendar" 
			@close="onCloseDialog"
		/>
		<TCHeader
			@move-to-today="moveToToday"
			v-on:change-filter-name="onChangeFilterName"
		/>
		<div class="tc-board-outer" :style="styleBoardOuter">
			<div class="d-flex">
				<TCHeaderList 
					v-on:show-rightpane-memberlist="showRightPaneMemberList"
					v-on:show-rightpane-projectlist="showRightPaneProjectList"/>
				<TCHeaderChart 
					@hscroll-start="onHScrollStart"
					@show-calendar="showDialogCalendar"
				/>
			</div>
			<div class="tc-content-outer" :style="styleContentOuter" v-statemachine="sm_hscroll">
				<div class="d-flex" style="width:100%;">
					<TCScheduleList
						v-bind:items="displayList"
						v-bind:scroll_to="schedule_list_scroll_to"
						v-on:add-task-info="onClickAddTaskInfo"
						v-on:show-task-info="showRightPaneTaskInfo"
						v-on:delete-task="onDeleteTaskWithConfirmation"
						v-on:show-member-info="showRightPaneMemberInfo"
						v-on:show-project-info="showRightPaneProjectInfo"
					/>
					<div class="tc-content-layer-outer">
						<div :style="styleLayerInner" :class="classLayerInner">
							<TCLayerBackground />
							<TCLayerChart
								v-bind:items="displayList"
								v-bind:isEditable="$store.getters['chart/isEditable']"
								v-bind:ghost_schedule="ghost_schedule"
								v-bind:bar_editing="bar_editing"
								@hscroll-start="onHScrollStart"
								@hscroll-stop="onHScrollStop"
								@bar-move-start="barMoveStart"
								v-on:request-ghost-schedule="onRequestGhostSchedule"
								v-on:bar-stretch-start="barStretchStart"
								v-on:update_schedule_info="showDialogScheduleInfo" />
						</div><!-- layer-inner -->
					</div><!-- layer-outer -->
				</div>
			</div><!-- tc-content-outer -->
			<div id="tc-hscroll" class="tc-hscroll-outer" :style="styleHScrollOuter" @scroll="onHScroll">
				<div class="tc-hscroll-inner" :style="styleHScrollInner" />
			</div>
		</div><!-- tc-board-outer -->
		<RightPaneTaskInfo
			v-bind:value="right_pane.task_info"
			v-on:close="onCloseRightPane('task_info')"
			v-on:show-rightpane-projectlist="showRightPaneProjectList"
			v-on:show-rightpane-memberlist="showRightPaneMemberList"
			v-on:update-task="onUpdateTask"
			v-on:delete-task="onDeleteTask"
		/>
		<RightPaneMemberInfo
			v-bind:value="right_pane.member_info"
			v-on:close="onCloseRightPane('member_info')"
		/>
		<TCRightPaneProjectInfo
			v-bind:value="right_pane.project_info"
			v-on:close="onCloseRightPane('project_info')"
		/>
		<RightPaneProjectList
			v-bind:value="right_pane.project_list"
			v-on:project-selected="onSelectProject"
			v-on:show-project-info="showRightPaneProjectInfo"
			v-on:close="onCloseRightPane('project_list')"
		/>
		<RightPaneMemberList
			v-bind:value="right_pane.member_list"
			v-on:member-selected="onSelectMember"
			v-on:show-member-info="showRightPaneMemberInfo"
			v-on:close="onCloseRightPane('member_list')"
		/>
	</div>
</template>
<script>
import TCHeader from './TCHeader';
import TCHeaderList from './TCHeaderList';
import TCHeaderChart from './TCHeaderChart';
import TCScheduleList from './TCScheduleList';
import TCLayerBackground from './TCLayerBackground';
import TCLayerChart from './TCLayerChart';
import Dialog from '../Dialog';
import TCDialogScheduleInfo from './TCDialogScheduleInfo';
import TCDialogCalendar from './TCDialogCalendar';

import _ from 'lodash';
import clonedeep from 'lodash/cloneDeep';
import Util from '../../classes/Util';
import LongPressEventData from '../../classes/LongPressEventData';
import MouseStateMachine from '../../classes/MouseStateMachine';
import MouseState from '../../classes/MouseState';
import { CHART_TICK, FORM_MODE } from '../../classes/Const';
import RightPaneTaskInfo from '../RightPaneTaskInfo';
import RightPaneMemberInfo from '../RightPaneMemberInfo';
import TCRightPaneProjectInfo from './TCRightPaneProjectInfo';
import RightPaneProjectList from '../RightPaneProjectList';
import RightPaneMemberList from '../RightPaneMemberList';

const onHScrollMove = _.throttle(function(thiz, e) {
	if (!thiz.hscroll.enabled)
		return;

	let amount = e.pageX - thiz.hscroll.x;
	if (amount == 0)
		return;

	thiz.hscroll.x = e.pageX;
	thiz.$store.dispatch('chart/hscrollMove', amount);
}, 10);

const disableHScroll = (thiz) => {
	thiz.hscroll.enabled = false;
};

const findTCList = (elem) => {
	let found = null;

	if (elem.classList.contains('tc-schedule-list')) {
		found = elem;
	} else {
		found = elem.closest('.tc-schedule-list');
	}

	return found;
};

export default {
	data () {
		let state_hscroll_default = new MouseState({
			down: (e) => {
				let obj = e.targetTouches ? e.targetTouches[0] : e;
				let found = findTCList(document.elementFromPoint(obj.pageX, obj.pageY));
				if (!found)
					this.onHScrollStart({x: obj.pageX});
			},
		});
		return {
			interval: null,
			hscroll: {
				enabled: false,
				x: 0,
			},
			sm_mypointer: null,
			sm_mouse: null,
			sm_hscroll: new MouseStateMachine(state_hscroll_default),
			long_press_event: new LongPressEventData(),
			pointer_event: {
				up: { handler: null },
				down: { handler: null },
			},
			right_pane: {
				project_info: null,
				member_list: null,
				project_list: null,
				task_info: null,
				member_info: null,
			},
			event_target: null,
			ghost_schedule: null,
			bar_editing: {
				is_editing: false,
				before_schedule: null,
			},
			dialog: {
				display: false,
				title: null,
				text: null,
				disagree: null,
				agree: null,
			},
			filter_name: '',
			dialog_schedule_info: {
				display: false,
				target: null,
				schedules: null,
			},
			schedule_list_scroll_to: null,
			dialog_calendar: {
				display: false,
			},
		}
	},
	components: {
		TCHeader,
		TCHeaderList,
		TCHeaderChart,
		TCScheduleList,
		TCLayerBackground,
		TCLayerChart,
		RightPaneTaskInfo,
		RightPaneMemberInfo,
		TCRightPaneProjectInfo,
		RightPaneProjectList,
		RightPaneMemberList,
		Dialog,
		TCDialogScheduleInfo,
		TCDialogCalendar,
	},
	methods: {
		onInterval: function () {
			this.$store.commit('chart/nowTime', new Date());
		},
		onHScrollStart: function(e) {
			this.hscroll.x = e.x;
			this.hscroll.enabled = true;
		},
		onHScrollStop: function() {
			disableHScroll(this);
		},
		onHScroll: function(e) {
			let scroll = e.target.scrollLeft;
			this.$store.commit('chart/hscroll', scroll);
		},
		onMouseMove: function(e) {
			let obj = e.targetTouches && e.targetTouches.length > 0 ? e.targetTouches[0] : e;
			
			/* for long press */
			this.long_press_event.refresh_mouse_pointer_from_event(obj);

			onHScrollMove(this, obj);
			
			if(this.event_target){
				this.onBarMove(obj);
			}
		},
		onMouseUp: function(e) {
			disableHScroll(this);
			let obj = e.changedTouches ? e.changedTouches[0] : e;
			
			if(this.event_target){
				this.ghost_schedule = null;
				this.event_target = null;
				this.bar_editing.is_editing = false;
				this.bar_editing.before_schedule = null;
			}
		},
		onPageShow: function(e) {
			if (e.persisted)
				window.location.reload();
		},
		onWindowResize: function() {
			Util.onWindowResize(() => {
				this.$store.commit('setWindowSize', {
					width: window.innerWidth,
					height: window.innerHeight,
					client_width: document.documentElement.clientWidth,
					client_height: document.documentElement.clientHeight,
				});
			});
		},
		moveToToday: function() {
			this.$store.dispatch('chart/moveToToday');
		},
		barMoveStart: function(e) {
			if(this.event_target === null) {
				this.event_target = e;
				this.bar_editing.is_editing = true;
				this.bar_editing.before_schedule = clonedeep(e.target.item);
			}
		},
		barStretchStart: function(e) {
			if(this.event_target === null) {
				this.event_target = e;
				this.bar_editing.is_editing = true;
				this.bar_editing.before_schedule = clonedeep(e.target.item);
			}
		},
		onBarMove: function(obj) {
			if(this.event_target.isScheduleMove) {
				this.onBarMoveScheduleMove(obj);
			} else if(this.event_target.isScheduleStrechBegin) {
				this.onBarMoveScheduleStrechBegin(obj);
			} else if(this.event_target.isScheduleStrechEnd) {
				this.onBarMoveScheduleStrechEnd(obj);
			}
		},
		onBarMoveScheduleMove: function(obj) {
			let target = this.event_target.target.$el;
			let source_date = this.$store.getters.createDateCurrentBeginningDay;
			let begin_as_minutes = this.bar_editing.before_schedule.begin.getDiffFromDateAsMinutes(source_date);
			let chart_tick = this.$store.getters['chart/chartTick'];
			let left_from = this.$store.getters['chart/computeWidthFromMinutes'](begin_as_minutes);
			let move = Math.floor(obj.pageX) - Math.floor(this.event_target.x);
			let left_to = left_from + move;
			
			let tick = Math.trunc(move / chart_tick.size);
			let begin_tick = this.bar_editing.before_schedule.begin.clone();
			let end_tick = this.bar_editing.before_schedule.end.clone();
			
			begin_tick.addMinutes(tick * chart_tick.minutes);
			end_tick.addMinutes(tick * chart_tick.minutes);
			
			this.$store.dispatch('updateSchedule', {
				schedule_code: this.bar_editing.before_schedule.code,
				project_code: this.bar_editing.before_schedule.project_code,
				task_code: this.bar_editing.before_schedule.task_code,
				begin_code: begin_tick.code,
				end_code: end_tick.code,
			});
		},
		onBarMoveScheduleStrechBegin: function(obj) {
			let target = this.event_target.target.$el;
			let chart_tick = this.$store.getters['chart/chartTick'];
			let source_begin = this.$store.getters.createDateCurrentBeginningDay;
			let source_end = clonedeep(source_begin);
			source_end.setHours(source_end.getHours() + 24);
			let begin_as_minutes = this.bar_editing.before_schedule.begin.getDiffFromDateAsMinutes(source_begin);
			let end_as_minutes = this.bar_editing.before_schedule.end.getDiffFromDateAsMinutes(source_end) + (24 * 60);
			
			let left_from = this.$store.getters['chart/computeWidthFromMinutes'](begin_as_minutes);
			let width_from = this.$store.getters['chart/computeWidthFromMinutes'](end_as_minutes - begin_as_minutes);
			let move = Math.floor(obj.pageX) - Math.floor(this.event_target.x);
			let left_to = left_from + move;
			let width_to = width_from - move;
			
			if(width_to < chart_tick.size)
				width_to = chart_tick.size;
			
			let begin_tick = null
			if(width_to > chart_tick.size) {
				let tick = tick = Math.trunc(left_to / chart_tick.size);
				let minutes = tick * chart_tick.minutes;
				begin_tick = this.bar_editing.before_schedule.begin.clone();
				begin_tick.addMinutes(Math.round(minutes - begin_as_minutes));
			} else {
				begin_tick = this.bar_editing.before_schedule.end.clone();
				begin_tick.addMinutes(-1 * chart_tick.minutes);
			}
			this.$store.dispatch('updateSchedule', {
				schedule_code: this.bar_editing.before_schedule.code,
				project_code: this.bar_editing.before_schedule.project_code,
				task_code: this.bar_editing.before_schedule.task_code,
				begin_code: begin_tick.code,
			});
		},
		onBarMoveScheduleStrechEnd: function(obj) {
			let target = this.event_target.target.$el;
			let chart_tick = this.$store.getters['chart/chartTick'];
			
			let source_begin = this.$store.getters.createDateCurrentBeginningDay;
			let source_end = clonedeep(source_begin);
			source_end.setHours(source_end.getHours() + 24);
			let begin_as_minutes = this.bar_editing.before_schedule.begin.getDiffFromDateAsMinutes(source_begin);
			let end_as_minutes = this.bar_editing.before_schedule.end.getDiffFromDateAsMinutes(source_end) + (24 * 60);
			
			let width_from = this.$store.getters['chart/computeWidthFromMinutes'](end_as_minutes - begin_as_minutes);
			let move = Math.floor(obj.pageX) - Math.floor(this.event_target.x);
			let width_to = width_from + move;
			
			if(width_to < chart_tick.size)
				width_to = chart_tick.size;
			
			let end_tick = null
			if(width_to > chart_tick.size) {
				let left = this.$store.getters['chart/computeWidthFromMinutes'](begin_as_minutes);
				let tick = tick = Math.trunc((left + width_to) / chart_tick.size);
				let minutes = tick * chart_tick.minutes;
				end_tick = this.bar_editing.before_schedule.end.clone();
				end_tick.addMinutes(Math.round(minutes - end_as_minutes));
			} else {
				end_tick = this.bar_editing.before_schedule.begin.clone();
				end_tick.addMinutes(chart_tick.minutes);
			}
			this.$store.dispatch('updateSchedule', {
				schedule_code: this.bar_editing.before_schedule.code,
				project_code: this.bar_editing.before_schedule.project_code,
				task_code: this.bar_editing.before_schedule.task_code,
				end_code: end_tick.code,
			});
		},
		onRequestGhostSchedule: function(e) {
			this.ghost_schedule = clonedeep(e);
		},
		showRightPaneProjectInfo: function(e){
			this.right_pane.project_info = clonedeep(e);
		},
		showRightPaneProjectList: function(e){
			this.right_pane.project_list = clonedeep(e);
		},
		showRightPaneMemberList: function(e){
			this.right_pane.member_list = clonedeep(e);
		},
		onSelectMember: function(e) {
			if (!this.right_pane.task_info || !this.right_pane.task_info.task) {
				this.$store.dispatch('chart/setDisplayListTypeMember');
				this.$store.dispatch('chart/setToggleAllExpandMember');
				this.$store.dispatch('setCurrentDate', new Date());
				this.$nextTick()
					.then(() => {
						this.schedule_list_scroll_to = e;
					})
					.then(() => {
						this.schedule_list_scroll_to = null;
					});
				
				this.onCloseRightPane('member_list');
				return;
			}
			this.right_pane.task_info.task.member_code = e;
			this.onCloseRightPane('member_list');
		},
		onSelectProject: function(e) {
			if (!this.right_pane.task_info || !this.right_pane.task_info.task) {
				this.$store.dispatch('chart/setDisplayListTypeProject');
				this.$store.dispatch('chart/setToggleAllExpandProject');
				let project = this.$store.getters['project'](e);
				let target_schedule = null;
				if(project.schedules.length > 1) {
					project.schedules.forEach(s => {
						if(target_schedule === null || target_schedule.begin.asDate > s.begin.asDate)
							target_schedule = clonedeep(s);
					});
				} else {
					target_schedule = project.schedules[0];
				}
				this.$store.dispatch('setCurrentDate', target_schedule.begin.asDate);

				if (!target_schedule.all_day) {
					let minutes = (target_schedule.begin.asDate.getHours() * 60) + target_schedule.begin.asDate.getMinutes();
					let tick = this.$store.getters['chart/chartTick'];
					let offset = (minutes / tick.minutes * tick.size) - (tick.size * 4);
					this.$store.commit('chart/hscroll', offset);
				}

				this.$nextTick()
					.then(() => {
						this.schedule_list_scroll_to = e;
					})
					.then(() => {
						this.schedule_list_scroll_to = null;
					});
				this.onCloseRightPane('project_list');
				return;
			}
			this.right_pane.task_info.task.project_code = e;
			this.onCloseRightPane('project_list');
		},
		onClickAddTaskInfo: function(e) {
			this.right_pane.task_info = {
				task: clonedeep(e),
				mode: FORM_MODE.ENTRY,
				display_type: this.$store.getters['chart/displayListType'],
			};
		},
		showRightPaneTaskInfo: function(e) {
			this.right_pane.task_info = {
				task: clonedeep(e),
				mode: this.$store.getters['chart/isEditable'] ? FORM_MODE.EDIT : FORM_MODE.REFERENCE,
				display_type: this.$store.getters['chart/displayListType'],
			};
		},
		showRightPaneMemberInfo: function(e){
			this.right_pane.member_info = {
				member: clonedeep(e),
				mode: this.$store.getters['chart/isEditable'] ? FORM_MODE.EDIT : FORM_MODE.REFERENCE,
			};
		},
		onCloseRightPane: function(name) {
			if (this.right_pane[name]) {
				this.right_pane[name] = null;
			}
		},
		showDialogScheduleInfo: function(e) {
			this.dialog_schedule_info.display = true;
			this.dialog_schedule_info.target = e.target;
			this.dialog_schedule_info.schedules = e.schedules;
		},
		onCloseDialog: function() {
			if (this.dialog_schedule_info.display) {
				this.dialog_schedule_info.display = false;
				this.dialog_schedule_info.target = null;
				this.dialog_schedule_info.schedules = null;
			}
			if (this.dialog_calendar.display) {
				this.dialog_calendar.display = false;
			}
		},
		displayErrorDialog: function(text) {
			this.dialog.title = 'エラー';
			this.dialog.text = text;
			this.dialog.disagree = null;
			this.dialog.agree = () => {
				this.dialog.display = false;
				this.dialog.agree = null;
			};
			this.dialog.display = true;
		},
		displayConfirmationDialog: function(text, agree) {
			this.dialog.title = '確認';
			this.dialog.text = text;
			this.dialog.disagree = () => {
				this.dialog.display = false;
			};
			this.dialog.agree = agree;
			this.dialog.display = true;
		},
		onClickDisagree: function() {
			if (this.dialog.disagree)
				this.dialog.disagree();
			return;
		},
		onClickAgree: function() {
			if (this.dialog.agree)
				this.dialog.agree();
			return;
		},
		showDialogCalendar: function() {
			this.dialog_calendar.display = true;
		},
		onUpdateTask: function(e) {
			this.$store.dispatch('updateDataTask', e).then((res) => {
				if (!res)
					this.displayErrorDialog('更新対象が削除されています');
			});
		},
		onDeleteTask: function(code) {
			this.$store.dispatch('deleteDataTask', code).then((res) => {
				if (!res)
					this.displayErrorDialog('更新対象が削除されています');
			});
		},
		onDeleteTaskWithConfirmation: function(e) {
			const agree = () => {
				this.dialog.display = false;
				this.dialog.agree = null;
				this.onDeleteTask(e);
			};
			this.displayConfirmationDialog('タスクを削除しますが、よろしいでしょうか', agree);
		},
		onChangeFilterName: function(e) {
			if (!e) {
				this.filter_name = '';
				return;
			}
			this.filter_name = e;
		},
	},
	computed: {
		styleBoardOuter: function() {
			let left = this.$store.getters['chart/boardLeftPosition'];
			let width = this.$store.getters['windowWidth'] - left;
			return {
				'width': width + 'px',
				'left': left + 'px',
			};
		},
		styleContentOuter: function() {
			let hscroll_height = 19;
			let ua = navigator.userAgent;
			if (Util.isiOS() || ua.indexOf('Android') > 0) {
				hscroll_height = 0;
			}
			let header = 160;

			return {
				height: (this.$store.getters['windowHeight'] - header - hscroll_height) + 'px',
			};
		},
		styleLayerInner: function() {
			return {
				position: 'relative',
				height: '100%',
				width: (this.$store.getters['chart/innerWidth']) + 'px',
				left: (- this.$store.getters['chart/hscroll']) + 'px',
			};
		},
		classLayerInner: function() {
			let classes = [];

			if (this.$store.getters['chart/isScrollingToNow']) {
				classes.push('transition-move-to-now');
			}

			return classes;
		},
		styleHScrollOuter: function() {
			let margin_left = this.$store.getters['chart/listWidth'] - this.$store.getters['chart/boardLeftPosition'];
			return {
				'margin-left': margin_left + 'px',
			};
		},
		styleHScrollInner: function() {
			let width = this.$store.getters['chart/innerWidth'];
			return {
				width: width + 'px',
			};
		},
		positionHScroll: function() {
			return this.$store.getters['chart/hscroll'];
		},
		displayList: function() {
			let ret = new Array();
			if (!this.filter_name) {
				ret = this.$store.getters['chart/display_list'];
			} else {
				ret = this.$store.getters['chart/display_list'].filter( row => {
					return row.name.search(Util.replaceEscapeString(this.filter_name)) >= 0;
				});
			}
			return ret;
		},
	},
	watch: {
		positionHScroll: function(value) {
			let hscroll = this.$el.querySelector('#tc-hscroll');
			hscroll.scrollLeft = value;
		},
	},
	created: function() {
		/* event pointer */
		this.pointer_event.down.handler = (e) => {
			let obj = e.targetTouches ? e.targetTouches[0] : e;
			let event = new CustomEvent('my-pointerdown', {
				bubbles: true,
				cancelable: true,
				detail: obj,
			});
			this.long_press_event.refresh_mouse_pointer_from_event(obj);

			e.target.dispatchEvent(event);
		};
		this.pointer_event.up.handler = (e) => {
			let obj = e.targetTouches ? e.targetTouches[0] : e;
			let event = new CustomEvent('my-pointerup', {
				bubbles: true,
				cancelable: true,
				detail: obj,
			});
			e.target.dispatchEvent(event);
		};
		
		const state_default = new MouseState({
			down: (e, next) => {
				this.pointer_event.down.handler(e);
				next(state_moving_mypointer);
			},
		});
		const state_moving_mypointer = new MouseState({
			up: (e, next) => {
				this.pointer_event.up.handler(e);
				next(state_default);
			},
		});
		this.sm_mypointer = new MouseStateMachine(state_default, true);
		this.sm_mypointer.bind(window);
		
		/* event longpress */
		const ON_POINTER_UP = (e) => {
			let event = new CustomEvent('long-press-stop', {
				bubbles: true,
				cancelable: true,
			});
			clearTimeout(this.long_press_event.timer);
			e.target.dispatchEvent(event);
			document.removeEventListener('my-pointerup', ON_POINTER_UP);
		};
		const ON_POINTER_DOWN = (e) => {
			let event = new CustomEvent('long-press-start', {
				bubbles: true,
				cancelable: true,
			});
			let obj = this.long_press_event.create_mouse_point(e.detail);
			document.addEventListener('my-pointerup', ON_POINTER_UP);
			this.long_press_event.timer = setTimeout(() => {
				if (this.long_press_event.validate_mouse_pointer(obj)) {
					e.target.dispatchEvent(event);
				}
			}, 500);
		};
		document.addEventListener('my-pointerdown', ON_POINTER_DOWN);
		this.long_press_event.handler = ON_POINTER_DOWN;
		
		const state_moving_mouse = new MouseState({
			move: (e) => {
				this.onMouseMove(e);
			},
			up: (e) => {
				this.onMouseUp(e);
			},
		});
		
		this.sm_mouse = new MouseStateMachine(state_moving_mouse);
		this.sm_mouse.bind(window);
		
		window.addEventListener('pageshow' , this.onPageShow, false);
		window.addEventListener('resize', this.onWindowResize, false);

		this.onWindowResize();
	},
	mounted: function() {
		this.interval = window.setInterval(this.onInterval, 120 * 1000);
		this.onInterval();
		this.$store.dispatch('chart/moveToNow');
	},
	beforeDestroy: function() {
		window.clearInterval(this.interval);

		document.removeEventListener('my-pointerdown', this.long_press_event.handler);
		window.removeEventListener('resize', this.onWindowResize);
		window.removeEventListener('pageshow' , this.onPageShow);
		this.sm_mypointer.unbind();
		this.sm_mouse.unbind();
	},
};
</script>
<style>
	.gantt-time-board-chart {
		width: 100%;
		background-color: #ededed;
		-moz-user-select: none;
		-webkit-user-select: none;
		-ms-user-select: none;
		transition:1s,
	}

	.tc-board-outer {
		position: absolute;
		transition: left ease .3s;
		border-top: 1px solid white;
	}

	.tc-content-outer {
		overflow-x: hidden;
		overflow-y: scroll;
		width: 100%;
		-webkit-overflow-scrolling: touch;
	}

	.tc-content-layer-outer {
		overflow: hidden;
		width: 100%;
	}

	.tc-hscroll-outer {
		overflow-x: scroll;
		overflow-y: hidden;
	}

	.tc-hscroll-inner {
		height: 1px;
	}

	.transition-move-to-now {
		transition: 1s;
	}
</style>
